import { SvgIconType } from './svg.interface';

const ArrowUpDown: SvgIconType = ({
  width = 8,
  height = 12,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.9999 1.81262L6.69339 4.50611C6.98655 4.79927 7.46187 4.79927 7.75503 4.50611C8.04819 4.21294 8.04819 3.73763 7.75503 3.44447L4.53023 0.21967C4.23734 -0.0732233 3.76247 -0.0732233 3.46957 0.21967L0.244776 3.44447C-0.0483887 3.73763 -0.0483887 4.21294 0.244776 4.50611C0.53794 4.79927 1.01325 4.79927 1.30642 4.50611L3.9999 1.81262Z"
      fill="#6A7383"
    />
    <path
      d="M7.75503 7.49389C7.46187 7.20073 6.98655 7.20073 6.69339 7.49389L3.9999 10.1874L1.30642 7.49389C1.01325 7.20073 0.53794 7.20073 0.244776 7.49389C-0.0483887 7.78706 -0.0483887 8.26237 0.244776 8.55553L3.46957 11.7803C3.76247 12.0732 4.23734 12.0732 4.53023 11.7803L7.75503 8.55553C8.04819 8.26237 8.04819 7.78706 7.75503 7.49389Z"
      fill="#6A7383"
    />
  </svg>
);

export default ArrowUpDown;
